const _ = require('lodash');

module.exports = function () {
    return function (collectionZoneItems, searchTerm) {
        return _.filter(collectionZoneItems,
            function (collectionZoneItem) {
                // return the items if it is availablr or if search term are not empty
                return (typeof searchTerm !== 'undefined' && searchTerm.length > 0)
                    || collectionZoneItem.IsAvailable && !collectionZoneItem.IsRestricted;
            });
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-available-filter.js
 **/